import React from 'react';
import { Icon } from 'styles';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import { monitoringCommingSoonData, monitoringFeatures } from "./data";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
    withStyles,
} from '@material-ui/core';
import strings from 'strings';

const MONITORING_STRING = strings.MONITORINGS

const styles = (theme) => ({
    root: {
        padding: theme.spacing(4),
    },
    card: {
        backgroundColor: '#EBEEFF',
        boxShadow: "none",
        border: 'inherit!important',
        height: "100%"
    },
    listItem: {
        padding: "0 8px",
    },
    alertPaper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: '#f9f9ff',
        display: 'flex',
        justifyContent: 'space-between',
    },
    emailCard: {
        backgroundColor: '#eef0ff',
        display: 'inline-block',
        padding: theme.spacing(2),
        marginTop: theme.spacing(4),
        textAlign: 'center',
    },
});

function MonitoringCommingSoon({ classes }) {
    return (
        <Box className={classes.root}>
            <Grid container spacing={6}>
                <Grid item md={5}>
                    <Typography style={{ fontSize: "24px", letterSpacing: "0.3px" }} gutterBottom>
                        {MONITORING_STRING.COMING_SOON_TITLE}
                    </Typography>

                    <Typography style={{ fontSize: "15px", color: "" }} color="textSecondary" paragraph>
                        {MONITORING_STRING.COMING_SOON_DESCRIPTION}
                    </Typography>

                    <List>
                        <ListItem style={{ paddingLeft: 0 }}>
                            <Typography component="span" style={{ fontSize: 15, color: '#000', marginRight: "8px" }}>✔ </Typography>
                            <Typography component="span" variant="body2" color="textSecondary" style={{ fontSize: 15 }}>
                                {MONITORING_STRING.COMING_SOON_FEATURE_1}
                            </Typography>
                        </ListItem>
                        <ListItem style={{ paddingLeft: 0 }}>
                            <Typography component="span" style={{ fontSize: 15, color: '#000', marginRight: "8px" }}>✔ </Typography>
                            <Typography component="span" variant="body2" color="textSecondary" style={{ fontSize: 15 }}>
                                {MONITORING_STRING.COMING_SOON_FEATURE_2}
                            </Typography>
                        </ListItem>
                        <ListItem style={{ paddingLeft: 0 }}>
                            <Typography component="span" style={{ fontSize: 15, color: '#000', marginRight: "8px" }}>✔ </Typography>
                            <Typography component="span" variant="body2" color="textSecondary" style={{ fontSize: 15 }}>
                                {MONITORING_STRING.COMING_SOON_FEATURE_3}
                            </Typography>
                        </ListItem>
                    </List>
                </Grid>
                <Grid item md={7}>
                    <Box>
                        <Typography gutterBottom>
                            <NotificationsNoneOutlinedIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                            {MONITORING_STRING.COMING_SOON_ALERTS_TITLE}
                        </Typography>

                        {monitoringCommingSoonData.map((alert, i) => (
                            <Box sx={{ margin: "12px 0", padding: "8px", borderRadius: "10px", background: "#f1f5ff" }}>
                                <Grid container>
                                    <Grid item md={4} style={{ margin: "auto" }}>
                                        <Typography>{alert.name}</Typography>
                                    </Grid>
                                    <Grid item md={8}>
                                        <Box sx={{ display: "flex" }}>
                                            <Icon
                                                className='mr-3'
                                                title='Termination'
                                                fileName='monitoringAlert.svg'
                                            />
                                            <Box>
                                                <Typography>{alert.issue}</Typography>
                                                <Typography style={{ color: "#666666", fontSize: "12px" }}>{alert.startDate}</Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <Typography gutterBottom>
                {MONITORING_STRING.COMING_SOON_TRACK_TITLE}
            </Typography>

            <Grid container spacing={2}>
                {monitoringFeatures.map((feature, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card className={classes.card}>
                            <CardContent>
                                <Typography variant="subtitle1" color="primary">
                                    {feature.title}
                                </Typography>
                                <List dense>
                                    {feature.items.map((item, i) => (
                                        <ListItem key={i} className={classes.listItem}>
                                            <ListItemText style={{ color: "var(--rox-dark-green)" }} primary={`• ${item}`} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
                <Grid item xs={12} md={6}>
                    <Card className={classes.card} style={{ background: "#7288FF" }}>
                        <CardContent>
                            <Typography variant="body1" align="center" style={{ color: "#fff" }}>
                                {MONITORING_STRING.COMING_SOON_FEEDBACK} <br />
                                <strong>{MONITORING_STRING.COMING_SOON_FEEDBACK_EMAIL}</strong>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}

export default withStyles(styles)(MonitoringCommingSoon);
